export default __webpack_public_path__ + "static/media/TeamTrack.a7ed9ce0.svg";